module.exports = "./img/desktop_logo.6243d31.png";